<template>
  <s-filter
    :active="!!model"
    :label="label"
    :active-label="activeLabel"
    @clear="model = undefined"
    :disabled
  >
    <template #value>
      <slot name="option" v-bind="{option: options.find((o: Option) => o.value == model)}">
        {{ options.find((o: Option) => o.value == model)?.label }}
      </slot>
    </template>
    <template #default="{close}">
      <s-select-filter-content :options v-model="model" @close="close" :disabled>
        <template v-if="$slots.option" #option="{option}">
          <slot name="option" v-bind="{option}" />
        </template>
      </s-select-filter-content>
    </template>
  </s-filter>
</template>
<script setup lang="ts">
import SSelectFilterContent from '../SSelectFilterContent.vue';
import SFilter from '../SFilter.vue';

type Option = {value: string | number; label: string};

defineProps<{
  options: Array<Option>;
  disabled?: boolean;
  label: string;
  activeLabel?: string;
}>();

const emit = defineEmits(['clear']);
const model = defineModel<string | number | null>();
</script>
